var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mts-dialog',{attrs:{"visible":_vm.visible,"title":"Вложения к трансляции"},on:{"close":function($event){return _vm.$emit('close-panel')}}},[_c('PanelFile',{attrs:{"file-list":_vm.attachFile,"mode":true},on:{"click-file":_vm.onClickFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }